import { createFileRoute, Link } from '@tanstack/react-router'
import { useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import { ScrollArea } from '@/components/ui/scroll-area'
import { selectJobOverviewData } from '@/store/selectors'
import { RootState } from '@/store/store'

export const Route = createFileRoute('/job/$jobId/$date/signoff/complete')({
  component: JobSignOffCompletePage,
})

function JobSignOffCompletePage() {
  const { jobId } = Route.useParams()

  const { job } = useSelector((state: RootState) =>
    selectJobOverviewData(state, jobId)
  )

  if (!job) {
    return <div>Job not found</div>
  }

  return (
    <>
      {/* Content */}
      <div className="flex-1 flex">
        <div className="flex-1">
          <ScrollArea className="h-full">
            <div className="px-8 py-6 flex flex-col items-center justify-center min-h-full">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-blue-600 mb-4">
                  Thank you.
                </h2>
                <h3 className="text-2xl text-gray-700">
                  Please pass the device back to the operative.
                </h3>
              </div>

              <Link to="/">
                <Button variant="destructive" size="lg">
                  Return to Jobs
                </Button>
              </Link>
            </div>
          </ScrollArea>
        </div>
      </div>
    </>
  )
}
